<template>
  <div class="area">
    <div class="area_li" :class="{'active':tableData_index == i}" v-for="(e,i) in tableData" :key="i"
      @click="areaFn(i)">{{e.areaName}}</div>
    <div class="btns" v-if="show_edit">
      <div class="cancel" @click="add">新增</div>
      <div class="submit" @click="edit" v-if="tableData.length">修改</div>
      <div class="delete" @click="deleteFn" v-if="tableData.length">删除</div>
    </div>
    <!-- 添加弹窗 -->
    <div class="add_box" v-if="add_status">
      <div class="tit">{{tit}}</div>
      <div class="name">
        分区名称：<div class="inp_box"><input class="search" placeholder="请输入名称" v-model="addData.areaName" type="text" />
        </div>
      </div>
      <div class="caozuo">
        <div class="cancel" @click="add_status =false">取消</div>
        <div class="submit" @click="addYes">保存</div>
      </div>
    </div>


  </div>
</template>


<script>

  export default {
    name: 'appMenu',
    props: ['area_data','show_edit'],
    data () {
      return {
        delContent: '是否删除分区？',
        delShow: false,
        tit: '新增分区',
        addData: {
          "areaName": "",
          "groupId": 0
        },
        id: '',
        add_status: false,
        tableData: [{
          areaName: 'A栋102'
        },{
          areaName: 'A栋302'
        },{
          areaName: 'A栋303'
        },{
          areaName: 'A栋304'
        },],
        tableData_index: 0,
      };
    },
    methods: {
      // 确定删除
      delItem (e) {

      },
      deleteFn (e) {
        this.addData=Object.assign({},this.tableData[this.tableData_index]);
        this.delContent=`是否删除【${this.addData.areaName||''}】分区!`;
        this.delShow=true;
      },
      edit () {
        this.tit='编辑分区';
        this.addData=Object.assign({},this.tableData[this.tableData_index]);
        this.add_status=true;
      },
      add () {
        this.tit='新增分区';
        this.addData.areaName='';
        this.addData.groupId=this.id;;
        this.add_status=true;
      },
      addYes () {
        console.log(this.addData,'确认添加');
        if(!this.addData.areaName) {
          this.$refs.uToast.show({
            title: '请输入分区名称',
            type: 'info',
            icon: false
          })
          return
        }
        if(this.tit=='新增分区') {

        } else {
        }

      },
      areaFn (i) {
        this.$emit('eventName',this.tableData[i].id,)
        this.tableData_index=i;
      },
      getList (v) {
        console.log(v,'获取id');
        this.id=v;

      },

      goBack () {
        uni.navigateBack();
      },
      url (v,i,id) {
        uni.switchTab({
          url: `../../pages/${v}/${v}`
        })
        this.$store.commit('userStore/actived',i)
      }

    }
  }
</script>
<style scoped>
  .btns {
    display: flex;
    position: absolute;
    right: 10px;
  }

  .btns .delete {
    border-radius: 6px;
    background: #e84133;
    color: #fff;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
  }

  .btns .submit {
    border-radius: 6px;
    background: #21d86d;
    color: #fff;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
  }

  .btns .cancel {
    border-radius: 6px;
    background: #408dff;
    color: #fff;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
  }

  .add_box .caozuo {
    display: flex;
    padding: 10px;
    justify-content: center;
  }

  .add_box .inp_box {
    border: 1px solid #000;
    border-radius: 4px;
    padding-left: 10px;
  }

  .add_box .name {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin: 20px 0;
  }

  .add_box .tit {
    text-align: center;
    padding: 5px;
    font-size: 18px;
  }

  .add_box {
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 6px;
    width: 300px;
    color: #272A2F;
  }

  .add_box .submit {
    border-radius: 16px;
    background: #408DFF;
    color: #fff;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }

  .add_box .cancel {
    border-radius: 16px;
    background: #272a2faf;
    color: #ccc;
    width: 68px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
  }

  .area .active {
    background-color: #408dff;
    border-color: #408dff !important;
  }

  .area {
    display: flex;
    color: #fff;
    position: relative;
  }

  .area .area_li {
    border: 1px solid #fff;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 4px;
    margin-left: 20px;
    font-size: 20px;
  }
</style>